.jn{bottom:0.25rem;}